<template>
    <div class="outro page">
        <div class="score-panel">
            <img :src="`${app_path}/images/score.png`" alt="Score">
            <div class="star-row">
                <img :src="starOne" alt="">
                <img :src="starTwo" alt="">
                <img :src="starThree" alt="">
            </div>
            <span id="score">{{ getScore() }}</span>
        </div>
        <a v-if="showActionLink" :href="actionLink" :target="actionTarget" class="router-button primary">{{ actionText }}</a>
        <router-button mode="secondary" to="intro">{{ text.button_replay }}</router-button>
    </div>
</template>

<script>
// @ is an alias to /src
import RouterButton from '@/components/RouterButton.vue'

export default {
    name: 'outro',
    components: {
        RouterButton
    },
    data: function() {
        return {
            text: window.config.text.outro,
            showActionLink: window.showAction,
            actionText: window.options.action.text,
            app_path: window.APP_PATH,
        };
    },
    computed: {
        actionLink() {
            if (window.options.action.type == 'next' && window.nextStepUrl) {
                return window.nextStepUrl;
            }
            if (window.options.action.type == 'external' && window.options.action.href) {
                return window.options.action.href;
            }
        },
        actionTarget() {
            if (window.options.action.type == 'external' && window.options.action.href) {
                return "_blank";
            }
            return '_self';
        },
        starOne() {
            if (this.getScore() >= 10) {
                return this.app_path + '/images/star-solid.svg';
            }
            return this.app_path + '/images/star.svg';
        },
        starTwo() {
            if (this.getScore() >= 20) {
                return this.app_path + 'images/star-solid.svg';
            }
            return this.app_path + 'images/star.svg';
        },
        starThree() {
            if (this.getScore() >= 30) {
                return this.app_path + 'images/star-solid.svg';
            }
            return this.app_path + 'images/star.svg';
        }
    },
    methods: {
        getScore() {
            let score =  window.APP.score;
            if (score < 0) {
                return 1;
            }
            return score;
        }
    }
}
</script>

<style lang="scss">
.outro {
    height: calc(100% - 40px);
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .router-button {
        margin: 0 auto;
    }
}
.score-panel {
    position: relative;
    text-align: center;
    margin:auto;

    & > img {
        display:block;
        max-width: 100%;
        height: auto;
    }
    .star-row {
        display: flex;
        flex-direction: row;
        flex-wrap:  nowrap;
        justify-content: space-around;
        width: 50%;
        margin: 0 auto;
        position: absolute;
        top: 180px;
        left: 50%;
        transform:translateX(-50%);
        align-items: flex-start;

        img {
            max-width: 50px;
        }
    }

    #score {
        font-size:48px;
        position: absolute;
        bottom: 60px;
        text-align: center;
        left: 50%;
        transform:translateX(-50%);
        font-family:'VarelaRound', sans-serif;
    }
}
</style>
